<template>
  <!-- A page with views, on a phone: the page's name small above the view's, which opens the views. -->
  <button
    type="button"
    class="base-view-switcher"
    aria-haspopup="dialog"
    :aria-label="$t('page.tenders.views.switch', { name: view })"
    @click="$emit('click')"
  >
    <span class="base-view-switcher__page">{{ page }}</span>
    <span class="base-view-switcher__view">
      <span class="base-view-switcher__name">{{ view }}</span>
      <BaseIcon name="chevron-down" class="base-view-switcher__car" />
    </span>
  </button>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';

// The title of a page with views on a phone, where the view tabs don't fit (docs/page-layout.md):
// both names in full, the page's on a small line above the view's.
export default {
  name: 'BaseViewSwitcher',
  components: { BaseIcon },
  props: {
    page: { type: String, required: true },
    view: { type: String, required: true },
  },
};
</script>

<style lang="scss">
.base-view-switcher {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 100%;
  min-height: 44px;
  padding: 0;
  font: inherit;
  color: inherit;
  text-align: left;
  text-transform: inherit;

  &__page {
    max-width: 100%;
    overflow: hidden;
    font-size: 11px;
    font-weight: bold;
    line-height: 14px;
    letter-spacing: 0.04em;
    color: $color-slate-500;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__view {
    display: flex;
    align-items: center;
    gap: 4px;
    max-width: 100%;
    line-height: 24px;
  }

  &__name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__car {
    flex: none;
    width: 20px;
    height: 20px;
    color: $color-slate-500;
  }
}
</style>
